import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { DealerLocation } from "models";

const component = "NoteSuggestionModal";

export const NoteSuggestionsQueryKeys = {
  location: backendQueryKey<DealerLocation>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/locations/details" })
};
